import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=5fa363ca&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa363ca')) {
      api.createRecord('5fa363ca', component.options)
    } else {
      api.reload('5fa363ca', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=5fa363ca&", function () {
      api.rerender('5fa363ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24iEPK75OUbSs/JS/pricehelp.vue"
export default component.exports